import React from 'react';
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./styles/font.css";
import App from "./App";
import "bootstrap";
import "bootstrap/dist/js/bootstrap.js";
import ErrorBoundary from './components/ErrorBoundary';
import  store  from './store'
import { Provider } from 'react-redux'
// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
     <Provider store={store}>
    <BrowserRouter>
      <ErrorBoundary>
    {/* <DndProvider backend={HTML5Backend}> */}
        <App />
      {/* </DndProvider> */}
      </ErrorBoundary>
    </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <ErrorBoundary>
//         <App />
//       </ErrorBoundary>
//     </BrowserRouter>
//   </React.StrictMode>,
//   document.getElementById("root")
// );
